import { TOGGLE_MODAL } from "../constants";

const initialState = {
  showModal: false,
  isCreate: false,
};

export default (state = initialState, action) => {
  switch (action.type) {
    case TOGGLE_MODAL:
      return {
        ...state,
        showModal: action.isModal,
        isCreate: action.isCreate ? action.isCreate : false,
      };
    default:
      return state;
  }
};
